export const teaching = [
	{
		"course": "Robot Navigation and Exploration",
		"job": "Teaching Assistant for CS562000, Spring 2020 & Spring 2022 at NTHU"
	},
	{
		"course": "Virtual Reality",
		"job": "Teaching Assistant for CS551100, Spring 2021 & Spring 2022 at NTHU"
	},
	{
		"course": "Introduction to Programming",
		"job": "Teaching Assistant for CS135501, Fall 2021 & Fall 2022 at NTHU"
	}
];